import { Link } from "react-router-dom";

export const Footer = () => {
	return (
		<div className="main-color">
			<footer
				className="container d-flex flex-wrap 
                justify-content-between align-items-center py-5 main-color"
			>
				<div className="col-md-2 mb-0 text-white">
					<p>ComicHQ - FullStack CRUD Project - Pedro Alcala</p>
					<p>
						All comics are property of MARVEL©, and assets are only
						used for development purposes.
					</p>
				</div>

				<div className="col-md-4 mb-0 text-white">
					<p>
						<a
							className="link-red"
							target="_blank"
							href="https://icons8.com/icon/ThjfS7nLQNeS/open-comic-book"
						>
							Open Comic Book
						</a>{" "}
						icon by{" "}
						<a
							className="link-red"
							target="_blank"
							href="https://icons8.com"
						>
							Icons8
						</a>
					</p>
					<p>
						Image by{" "}
						<a
							className="link-red"
							href="https://pixabay.com/users/qimono-1962238/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=1872634"
						>
							Arek Socha
						</a>{" "}
						from{" "}
						<a
							className="link-red"
							href="https://pixabay.com//?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=image&amp;utm_content=1872634"
						>
							Pixabay
						</a>
					</p>
				</div>
				<ul className="nav navbar-dark col-md-4 justify-content-end">
					<li className="nav-item">
						<Link
							href="#"
							className="nav-link px-2 text-white"
							to="/"
						>
							Home
						</Link>
					</li>
					<li className="nav-item">
						<Link
							href="#"
							className="nav-link px-2 text-white"
							to="search"
						>
							Search Comics
						</Link>
					</li>
				</ul>
			</footer>
		</div>
	);
};
